<template lang="pug">
div(class='relative')
  div(class='flex items-center gap-x-4 md:min-w-[70px] md:block md:space-y-1')
    div(v-if='!item.isVirtualItem' class='select')
      select(
        v-model='qty'
        :disabled='item.isFreeItem'
        class='!py-0 !px-[20px] !w-[72px]'
        data-testid='quantitySelect'
        aria-label='Change Quantity'
      )
        option(v-for='n in maxItemQty' :key='n' :value='n') {{ n }}

    span(v-else) {{ item.qty }}

    div(class='flex flex-row gap-x-4 md:flex-col items-center')
      button(v-if='!item.isVirtualItem && !item.isFreeItem' type='button' class='text-sm text-action' @click='removeItem') Remove

      button(
        v-if='isIntegrationEnabled("cognito") && !item.isVirtualItem && !item.isFreeItem'
        type='button'
        class='text-sm whitespace-nowrap text-action'
        @click='saveItemForLater'
      ) Save for later

  div(v-if='isLoading' class='bg-black opacity-50 absolute inset-0 flex justify-center items-center')
    div(class='loader !border-[5px] !w-8 !h-8')
</template>

<script lang="ts" setup>
const { $cognito, $uiEvents } = useNuxtApp()
const { isIntegrationEnabled } = useUtils()
const wishlist = useWishlist()
const notifications = useNotifications()
const log = useLogger('ITEM_ACTIONS')

const cart = useCart()

const { item } = defineProps<{
  item: CartItem
}>()

const isLoading = ref(false)

const qty = computed({
  get() {
    return item.qty
  },
  set(val: number) {
    updateQty(val)
  },
})

const maxItemQty = computed(() => {
  return maxQty(item.qty)
})

async function updateQty(qty: number) {
  if (isLoading.value) return
  isLoading.value = true

  try {
    await cart.updateItemQty(item.id, qty)
  } catch (error) {
    notifications.addError('Error', `Unable to update item quantity. Please try again later.`)
    log.error('Unable to update cart item quantity', { error })
  }

  isLoading.value = false
}

async function removeItem() {
  if (isLoading.value) return
  isLoading.value = true

  try {
    await cart.removeItem(item.id)
  } catch (error) {
    notifications.addError('Error', `Unable to delete item. Please try again later.`)
    log.error('Unable to delete cart item', { error })
  }

  isLoading.value = false
}

function saveItemForLater() {
  // early out if cognito is disabled
  if (!isIntegrationEnabled('cognito')) return
  $cognito.openModal(moveToWishlist)
}

async function moveToWishlist() {
  if (isLoading.value) return
  isLoading.value = true

  try {
    await wishlist.moveToWishlist(item)
    notifications.addSuccess('Moved item to list', `${item.productLineName} has been moved to saved items!`)
    $uiEvents.$emit('saveForLaterAdded', item)
  } catch (error) {
    notifications.addError('Error', `Unable to move item. Please try again later.`)
    log.error('Unable to move cart item to wishlist', { error })
  }

  isLoading.value = false
}
</script>
